import React from 'react';
import { Box, Button } from '@nimbus-ds/components';

function ControlsSkeleton(): JSX.Element {
  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="flex-end"
      gap="2"
      data-testid="Skeleton-WithdrawAmountForm-Controls"
    >
      <Button.Skeleton />
      <Button.Skeleton />
    </Box>
  );
}

export default ControlsSkeleton;
